import { styled } from '@mui/material/styles';
import RadioGroup from '@mui/material/RadioGroup';
import ModalBase from '@components/Modal/ModalBase';
import { Switch } from '@components/Switch';
import PhoneInput from '@components/PhoneInput';

export const Modal = styled(ModalBase)({
    '& .modal-base-paper': {
        width: 564,
        height: 'calc(100vh - 32px)',
        maxHeight: 'calc(100vh - 32px)',
        display: 'flex',
        flexDirection: 'column',
    },
    '& .modal-base-content': {
        padding: '24px 16px',
        flex: 1,
        overflow: 'auto',
    },
});

export const Form = styled('div')({
    display: 'grid',
    columnGap: 24,
    rowGap: 16,
    gridTemplateColumns: 'minmax(0, 1fr) minmax(0, 1fr)',
    '@media (max-width: 768px)': {
        gridTemplateColumns: 'minmax(0, 1fr)',
    },
});

export const StyledRadioGroup = styled(RadioGroup)({
    flexDirection: 'row',
    alignItems: 'center',
    marginBottom: 24,
    marginTop: 8,
    '& .MuiFormControlLabel-root': {
        marginRight: 24,
        marginLeft: 0,
    },
    '& .MuiFormControlLabel-label': {
        fontSize: '14px',
    },
});

export const StyledSwitch = styled(Switch)({
    marginTop: 0,
    marginBottom: 0,
});

export const StyledPhoneInput = styled(PhoneInput)({
    paddingBottom: 16,
    '& .error-message': {
        bottom: -14,
    },
});

export const GooglePlacesSection = styled('div')({
    display: 'flex',
    flexDirection: 'column',
    gap: 16,
});

export const FullWidthField = styled('div')({
    gridColumn: '1 / -1',
});
